import { Badge } from "@/components/common";
import type { UserStatus } from "@/types/rbac";

const statusConfig: Record<
  UserStatus,
  { label: string; variant: "success" | "warning" | "default" }
> = {
  active: { label: "Aktywny", variant: "success" },
  invited: { label: "Zaproszony", variant: "warning" },
  disabled: { label: "Wyłączony", variant: "default" },
};

interface StatusBadgeProps {
  status: UserStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status];
  return (
    <Badge variant={config.variant} dot>
      {config.label}
    </Badge>
  );
}
